import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Button, Link, Card } from '@sunrun/component-library';
import mixpanel from '../../utilities/mixpanel';
import StyledLibraryLink from './StyledLibraryLink';
import { MAX_DESKTOP_BREAKPOINT, MIN_DESKTOP_BREAKPOINT } from './constants/_breakpoints';
import { Color } from '@sunrun/mui-theme';
import { OFF_WHITE_20, PRODUCT_CARD_DARK_BLUE } from './constants/_colors';
const StyledCard = styled(Card) `
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  margin-bottom: ${props => (props.extraMargin ? '64px !important' : '15px')};
  background-color: ${Color.WHITE};
  position: relative;
  overflow: hidden;
  min-height: 166px;
  padding: 0 !important;

  @media only screen and (max-width: ${MAX_DESKTOP_BREAKPOINT}) {
    width: 100%;
  }
`;
const TextContainer = styled.div `
  align-self: center;
  margin-right: 10px;
  margin-top: 50px;
  padding: 0 28px;
  width: 100%;

  font-family: Roobert;
  font-size: 14px;
  font-weight: 400;

  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    width: ${props => (props.hasChildren ? 'calc(100% - 200px)' : '100%')};
    margin-top: 35px;
  }

  p {
    margin-top: 0;
    color: ${OFF_WHITE_20};
  }
`;
const StyledButton = styled(Button) `
  cursor: pointer;
  width: 100%;
`;
const StyledChildren = styled.div `
  width: 150px;
  z-index: 12;
  padding: 8px;
  padding-left: 0;

  @media only screen and (max-width: ${MAX_DESKTOP_BREAKPOINT}) {
    display: none;
  }
`;
const StyledHeaderText = styled.div `
  font-size: 16px;
  font-family: Roobert;
  font-weight: 750;
  position: absolute;
  background-color: ${PRODUCT_CARD_DARK_BLUE};
  color: ${Color.WHITE};
  padding: 10px 28px;
  left: 0;
  right: 0;
  z-index: 10;
`;
const AltContentCard = ({ button, children, header, link, text, extraMargin }) => {
    useEffect(() => {
        mixpanel.track(`Dashboard "${header}" Card Displayed`);
    }, []);
    return (React.createElement(StyledCard, { extraMargin: extraMargin },
        React.createElement(StyledHeaderText, null, header),
        React.createElement(TextContainer, { hasChildren: !!children },
            React.createElement("div", null,
                text && `${text} `,
                (link === null || link === void 0 ? void 0 : link.text) && (React.createElement(StyledLibraryLink, { target: link.target, href: link.href, onClick: link.onClick, to: link.to }, link.text))),
            (button === null || button === void 0 ? void 0 : button.text) && (button === null || button === void 0 ? void 0 : button.href) && (React.createElement(Link, { to: button.href },
                React.createElement(StyledButton, { primary: true, onClick: button.onClick }, button.text)))),
        React.createElement(StyledChildren, null, children)));
};
export default AltContentCard;
